module.exports = __webpack_public_path__ + "img/ExhibitionHall.62db4fdf.svg";